import { FieldType, Model, Schema } from "@core/index";
import { IContactNumber } from "./ContactNumber";

export interface ILuggageStatusRequest {
    mobileNumber?: IContactNumber;
    referenceNumber?: string;
}


export class LuggageStatusRequest extends Model implements ILuggageStatusRequest {
    public static schema: Schema = new Schema("LostBaggage");
    public mobileNumber?: IContactNumber = {};
    public referenceNumber?: string;

    constructor(values: ILuggageStatusRequest) {
        super(LuggageStatusRequest.schema);
        this.setValues(values);
    }
}

LuggageStatusRequest.schema.addField("mobileNumber").type(FieldType.Object).required();
LuggageStatusRequest.schema.addField("referenceNumber").type(FieldType.String).required();